export default __webpack_public_path__ + "static/media/detailsClosed.3c030173.svg";